import apiCategories from "@/api/categories";
import apiParticipant from "@/api/participant";
import apiCart from "@/api/cart";

const state = {
  cart: [],
  categories: [],
  participantOrders: [],
  participantOrderMessages: []
};

const actions = {
  getCategories({ commit }, eventId) {
    return apiCategories.all(eventId).then(({ data }) => {
      commit("SET_CATEGORIES", data);
    });
  },
  getCart({ commit }, eventId) {
    return apiCart.get(eventId).then(({ data }) => {
      commit("SET_CART", data);
    });
  },
  getParticipantOrders({ commit }, id) {
    return apiParticipant.getParticipantOrders(id).then(({ data }) => {
      commit("SET_PARTICIPANT_ORDERS", data);
    });
  },
  getParticipantOrderMessages({ commit }, { id, orderId }) {
    return apiParticipant
      .getParticipantOrderMessages(id, orderId)
      .then(({ data }) => {
        commit("SET_PARTICIPANT_ORDER_MESSAGES", data);
      });
  },
  updateParticipantOrderStatus({ state, commit }, order) {
    const updatedOrders = state.participantOrders.map(item => {
      if (item.id === order.id) {
        item.status = order.status;
      }
      return item;
    });
    commit("UPDATE_PARTICIPANT_ORDER_STATUS", updatedOrders);
  }
};

const mutations = {
  UPDATE_PARTICIPANT_ORDER_STATUS(state, participantOrders) {
    state.participantOrders = participantOrders;
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_CART(state, cart) {
    state.cart = cart;
  },
  SET_PARTICIPANT_ORDERS(state, orders) {
    state.participantOrders = orders;
  },
  SET_PARTICIPANT_ORDER_MESSAGES(state, messages) {
    state.participantOrderMessages = messages;
  },
  SET_PARTICIPANT_ORDER_MESSAGES_READ(state, id) {
    state.participantOrders.find(
      item => item.id === id
    ).unread_messages_count = 0;
  }
};

const getters = {
  isCartEmpty(state, getters) {
    return !getters.cartServicesList.length;
  },
  cartSum: (state, getters) => service => {
    let noPriceItems = 0;
    let services = getters.cartServicesList;
    // фильтр по услуге
    if (service) {
      services = services.filter(item => item.id === service.id);
    }
    let sum = services.reduce((price, item) => {
      if (!item.currencyPrice) {
        noPriceItems++;
      } else {
        return (
          price +
          item.count *
            parseFloat(item.currencyPrice.price_with_vat) *
            (item.dates && item.dates.length ? item.dates.length : 1)
        );
      }
    }, 0);
    return noPriceItems ? null : sum;
  },
  cartServicesList(state, getters) {
    let cart = [];
    state.cart.forEach(item => {
      if (item.items && item.items.length) {
        cart.push(
          ...item.items.map((i, index) => {
            let currencyPrice = i.service.prices.find(
              p =>
                getters.currency &&
                p.unit.id === i.unit.id &&
                p.currency === getters.currency.code
            );

            return {
              showExecutor: index === 0,
              // цена для вывода в корзине, зависит от выбранной валюты
              currencyPrice: currencyPrice,
              price: i.price,
              unit: i.unit,
              count: i.quantity,
              dates: i.dates,
              quantity_by_dates: i.quantity_by_dates,
              time_range_by_dates: i.time_range_by_dates,
              comment: i.comment,
              cart_item_id: i.id,
              ...i.service
            };
          })
        );
      }
    });
    return cart;
  },
  isSomeServiceRequired(state, getters) {
    return !!getters.cartServicesList.find(
      item => item.is_required_contract === true
    );
  },
  categories: state => state.categories,
  participantOrders: state => {
    return state.participantOrders;
  },
  participantOrderMessages: state => {
    return state.participantOrderMessages;
  },
  currency: (state, getters, rootState, rootGetters) => {
    return rootGetters["event/currency"] ? rootGetters["event/currency"] : "";
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
